import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, forkJoin } from 'rxjs';
import { AppService } from 'src/app/app.service';
import { UserService } from '../user/user.service';
import { catchError, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class DashboardService {

  private static SELECTED_ACCOUNT = "SELECTED_ACCOUNT";
  private static URL_POWERBI = "/PowerBI/getPowerBIReport";
  private static URL_GET_REPORT_DETAILS = "/getreportdetailsforcomponent";
  private static URL_GET_USER_ACCOUNTS = "/getuseraccountsbycomponent";
  private static URL_SAVE_REPORT = "/analyticssavereport";
  private static URL_PUBLISH_REPORT = "/analyticspublishreport";
  private static CLAIM_NUMBER = "CLAIM_NUMBER";
  private static CLAIMANT_NAME = "CLAIMANT_NAME";

  componentId$: BehaviorSubject<number>;

  constructor(
    private http: HttpClient,
    private appService: AppService,
    private userService: UserService
  ) { }

  getSelectedAccount(): string {
    return sessionStorage.getItem(DashboardService.SELECTED_ACCOUNT);
  }

  setSelectedAccount(account: number) {
    sessionStorage.setItem(DashboardService.SELECTED_ACCOUNT, account.toString());
  }

  getReportDetailsForComponent(componentId: number): Observable<any> {
    const payload = { componentId };
    return this.http
      .post(`${this.appService.getBaseUrl()}${DashboardService.URL_GET_REPORT_DETAILS}`, payload)
      .pipe(
        map((_: any) => {
          return _.responseData;
        }),
        catchError(error => error)
      )
      ;
  }

  getUserAccountsForComponent(componentId: number): Observable<any> {
    const payload = { componentId };
    return this.http
      .post(`${this.appService.getBaseUrl()}${DashboardService.URL_GET_USER_ACCOUNTS}`, payload)
      .pipe(
        map((_: any) => {
          return _.userAccount;
        }),
        catchError(error => error)
      );
  }

  getComponentDetails(componentId: number): Observable<any> {
    return forkJoin({
      reportDetails: this.getReportDetailsForComponent(componentId),
      userAccountDetails: this.getUserAccountsForComponent(componentId),
    })
  }

  getPowerBiReport(reportId: string, account: string, isClaimSearch: boolean): Observable<any> {
    const clientName: string = this.appService.getClientName();
    const username: string = isClaimSearch ? this.userService.getUserNo() : account;
    const url =
      `${this.appService.getBaseUrl()}${DashboardService.URL_POWERBI}?username=${username}&roles=userName&pbiReportId=${reportId}&clientName=${clientName}`;
    return this.http.get(url);
  }

  saveReport(reportData: any): Observable<any> {
    return this.http.post(`${this.appService.getBaseUrl()}${DashboardService.URL_SAVE_REPORT}`, reportData);
  }

  publishReport(publishData: any): Observable<any> {
    return this.http.post(`${this.appService.getBaseUrl()}${DashboardService.URL_PUBLISH_REPORT}`, publishData);
  }

  public getClaimNumber(): string {
    return sessionStorage.getItem(DashboardService.CLAIM_NUMBER);
  }

  public setClaimNumber(claimNumber: string) {
    sessionStorage.setItem(DashboardService.CLAIM_NUMBER, claimNumber);
  }

  public getClaimantName(): string {
    return sessionStorage.getItem(DashboardService.CLAIMANT_NAME);
  }

  public setClaimantName(setClaimantName: string) {
    sessionStorage.setItem(DashboardService.CLAIMANT_NAME, setClaimantName);
  }

}
